<template>
  <div class="privacy-page">
    <div class="background-glow background-glow--one"></div>
    <div class="background-glow background-glow--two"></div>

    <header class="topbar">
      <a href="/" class="brand" aria-label="Voltar para a página inicial do ControlEase">
        <div class="brand-icon" aria-hidden="true">
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="brand-text">
          <strong>ControlEase</strong>
          <small>Gestão financeira</small>
        </div>
      </a>

      <a href="/" class="home-button">
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M15 18l-6-6 6-6" />
        </svg>
        <span>Voltar para a home</span>
      </a>
    </header>

    <main class="privacy-shell">
      <section class="privacy-hero">
        <span class="eyebrow">Privacidade & Segurança</span>
        <h1>Política de Privacidade</h1>
        <p class="hero-description">
          Transparência sobre como seus dados são tratados, protegidos e utilizados
          dentro do ControlEase.
        </p>
        <div class="updated">
          <span class="updated-dot"></span>
          Última atualização: 26 de agosto de 2026
        </div>
      </section>

      <article class="privacy-container">
      <p>
        Esta Política de Privacidade descreve como o <strong>ControlEase</strong>
        ("nós", "nosso" ou "Plataforma") coleta, usa, armazena, compartilha e
        protege os dados pessoais dos usuários ("você" ou "titular"), em
        conformidade com a Lei nº 13.709/2018 (Lei Geral de Proteção de Dados
        Pessoais — LGPD).
      </p>

      <h2>1. Quem somos (Controlador dos Dados)</h2>
      <p>
        O ControlEase é operado por
        <strong>[NOME EMPRESARIAL — PLACEHOLDER]</strong>, inscrito(a) no
        CNPJ nº <strong>[CNPJ — PLACEHOLDER]</strong>, doravante denominado
        "Controlador", responsável pelo tratamento dos dados pessoais
        coletados por meio da Plataforma.
      </p>
      <p>
        Para dúvidas, solicitações ou exercício de direitos relacionados à
        proteção de dados, entre em contato através do e-mail:
        <strong>[privacidade@controlease.com.br — PLACEHOLDER]</strong>.
      </p>

      <h2>2. Quais dados coletamos</h2>
      <p>Coletamos as seguintes categorias de dados pessoais:</p>
      <ul>
        <li>
          <strong>Dados cadastrais:</strong> nome, nome de usuário, e-mail,
          telefone/WhatsApp, endereço e senha (armazenada de forma
          criptografada).
        </li>
        <li>
          <strong>Dados financeiros inseridos por você:</strong> gastos,
          receitas, metas financeiras, saldos bancários, investimentos,
          assinaturas de streaming, financiamentos e orçamentos de projetos
          que você cadastra voluntariamente na Plataforma para fins de
          controle financeiro pessoal.
        </li>
        <li>
          <strong>Dados de comunicação via WhatsApp:</strong> quando você
          interage com o assistente virtual do ControlEase pelo WhatsApp,
          coletamos o conteúdo das mensagens trocadas para processá-las e
          gerar respostas através de nosso agente de inteligência
          artificial.
        </li>
        <li>
          <strong>Dados de pagamento:</strong> processados por nosso parceiro
          de pagamentos (Stripe); não armazenamos números completos de
          cartão de crédito em nossos servidores.
        </li>
        <li>
          <strong>Dados de uso e acesso:</strong> informações técnicas como
          endereço IP, tipo de dispositivo, navegador e registros de acesso
          (logs), coletados automaticamente para segurança e melhoria do
          serviço.
        </li>
      </ul>

      <h2>3. Para que usamos seus dados (Finalidades)</h2>
      <ul>
        <li>Criar e gerenciar sua conta na Plataforma;</li>
        <li>
          Fornecer as funcionalidades de controle financeiro pessoal
          (gastos, receitas, metas, investimentos, etc.);
        </li>
        <li>
          Processar mensagens enviadas via WhatsApp e fornecer respostas
          através do assistente de inteligência artificial;
        </li>
        <li>
          Enviar notificações relevantes sobre sua conta, como lembretes de
          tarefas, vencimento de gastos, progresso de metas e renovação de
          assinaturas;
        </li>
        <li>Processar pagamentos e gerenciar sua assinatura do serviço;</li>
        <li>
          Garantir a segurança da Plataforma e prevenir fraudes ou uso
          indevido;
        </li>
        <li>
          Cumprir obrigações legais e regulatórias aplicáveis;
        </li>
        <li>Melhorar e desenvolver novas funcionalidades da Plataforma.</li>
      </ul>

      <h2>4. Bases legais para o tratamento</h2>
      <p>Tratamos seus dados pessoais com base nas seguintes hipóteses legais previstas no Art. 7º da LGPD:</p>
      <ul>
        <li>
          <strong>Execução de contrato:</strong> para fornecer os serviços
          que você contratou ao criar sua conta;
        </li>
        <li>
          <strong>Consentimento:</strong> para funcionalidades específicas,
          como o envio de notificações e mensagens via WhatsApp, quando
          aplicável;
        </li>
        <li>
          <strong>Legítimo interesse:</strong> para garantir a segurança da
          Plataforma e prevenir fraudes;
        </li>
        <li>
          <strong>Cumprimento de obrigação legal ou regulatória:</strong>
          quando exigido por lei.
        </li>
      </ul>

      <h2>5. Compartilhamento de dados com terceiros</h2>
      <p>
        Podemos compartilhar seus dados pessoais com os seguintes terceiros,
        estritamente para viabilizar o funcionamento da Plataforma:
      </p>
      <ul>
        <li>
          <strong>Meta Platforms, Inc. (WhatsApp Business API):</strong> para
          envio e recebimento de mensagens via WhatsApp;
        </li>
        <li>
          <strong>Stripe:</strong> para processamento seguro de pagamentos e
          gerenciamento de assinaturas;
        </li>
        <li>
          <strong>Provedores de infraestrutura em nuvem:</strong> para
          hospedagem segura de nossos servidores e banco de dados;
        </li>
        <li>
          <strong>Provedores de inteligência artificial:</strong> para
          processamento das mensagens enviadas ao assistente virtual e
          geração de respostas automatizadas;
        </li>
        <li>
          <strong>Autoridades públicas:</strong> quando exigido por lei,
          ordem judicial ou requisição de autoridade competente.
        </li>
      </ul>
      <p>
        Não vendemos seus dados pessoais a terceiros para fins de
        marketing ou publicidade.
      </p>

      <h2>6. Armazenamento e retenção de dados</h2>
      <p>
        Seus dados pessoais são armazenados enquanto sua conta estiver
        ativa, ou pelo tempo necessário para cumprir as finalidades
        descritas nesta Política, observadas eventuais obrigações legais de
        retenção. Após o término do uso ou solicitação de exclusão, os dados
        serão eliminados ou anonimizados, exceto quando a manutenção for
        exigida por lei (ex: obrigações fiscais e contábeis).
      </p>

      <h2>7. Seus direitos como titular de dados</h2>
      <p>Nos termos do Art. 18 da LGPD, você tem direito a:</p>
      <ul>
        <li>Confirmar a existência de tratamento de seus dados;</li>
        <li>Acessar seus dados pessoais;</li>
        <li>Corrigir dados incompletos, inexatos ou desatualizados;</li>
        <li>
          Solicitar anonimização, bloqueio ou eliminação de dados
          desnecessários ou tratados em desconformidade com a lei;
        </li>
        <li>Solicitar a portabilidade de seus dados a outro fornecedor;</li>
        <li>Eliminar os dados tratados com base no seu consentimento;</li>
        <li>
          Revogar o consentimento a qualquer momento, quando aplicável;
        </li>
        <li>
          Obter informações sobre as entidades públicas e privadas com as
          quais compartilhamos seus dados;
        </li>
        <li>
          Se opor a tratamento realizado com base em hipótese legal que não
          exija consentimento, em caso de descumprimento da LGPD.
        </li>
      </ul>
      <p>
        Para exercer qualquer um desses direitos, entre em contato pelo
        e-mail informado na Seção 1.
      </p>

      <h2>8. Segurança dos dados</h2>
      <p>
        Adotamos medidas técnicas e organizacionais para proteger seus dados
        pessoais contra acessos não autorizados, perda, alteração ou
        divulgação indevida, incluindo criptografia de senhas, controle de
        acesso baseado em autenticação (JWT), comunicação via HTTPS e
        segregação de permissões por perfil de usuário.
      </p>

      <h2>9. Cookies e tecnologias de rastreamento</h2>
      <p>
        A Plataforma pode utilizar cookies e tecnologias similares para
        manter sua sessão ativa, lembrar preferências e melhorar sua
        experiência de uso. Você pode gerenciar o uso de cookies através das
        configurações do seu navegador.
      </p>

      <h2>10. Crianças e adolescentes</h2>
      <p>
        O ControlEase não é direcionado a menores de 18 anos e não coleta
        intencionalmente dados de crianças e adolescentes. Caso identifiquemos
        o cadastro de um menor sem o devido consentimento dos responsáveis
        legais, tomaremos medidas para excluir os dados coletados.
      </p>

      <h2>11. Alterações nesta Política</h2>
      <p>
        Esta Política de Privacidade pode ser atualizada periodicamente para
        refletir mudanças em nossas práticas ou na legislação aplicável. A
        data da última atualização estará sempre indicada no topo desta
        página. Recomendamos que você a revise regularmente.
      </p>

      <h2>12. Contato e Encarregado de Dados (DPO)</h2>
      <p>
        Em caso de dúvidas sobre esta Política ou sobre o tratamento de
        seus dados pessoais, entre em contato com nosso Encarregado de
        Proteção de Dados através do e-mail:
        <strong>[privacidade@controlease.com.br — PLACEHOLDER]</strong>.
      </p>
      <p>
        Você também pode registrar reclamações junto à Autoridade Nacional
        de Proteção de Dados (ANPD), através do site
        <a href="https://www.gov.br/anpd" target="_blank" rel="noopener">gov.br/anpd</a>.
      </p>
      </article>

      <footer class="privacy-footer">
        <div>
          <strong>ControlEase</strong>
          <span>Controle financeiro de forma simples, clara e segura.</span>
        </div>
        <a href="/">Voltar para a página inicial</a>
      </footer>
    </main>
  </div>
</template>

<script setup>
</script>

<style scoped>
* {
  box-sizing: border-box;
}

.privacy-page {
  --primary: #6c63ff;
  --primary-strong: #5548f6;
  --primary-soft: rgba(108, 99, 255, 0.11);
  --accent: #21d4a7;
  --ink: #131522;
  --muted: #6f7281;
  --line: #ececf4;
  --surface: rgba(255, 255, 255, 0.92);

  position: relative;
  min-height: 100vh;
  overflow: hidden;
  padding: 24px 20px 48px;
  background:
    radial-gradient(circle at 8% -10%, rgba(108, 99, 255, 0.15), transparent 34%),
    radial-gradient(circle at 95% 10%, rgba(33, 212, 167, 0.12), transparent 28%),
    linear-gradient(180deg, #f8f9ff 0%, #f6f8fb 45%, #f9fafc 100%);
  color: var(--ink);
}

.background-glow {
  position: absolute;
  z-index: 0;
  width: 340px;
  height: 340px;
  border-radius: 999px;
  filter: blur(90px);
  pointer-events: none;
  opacity: 0.34;
}

.background-glow--one {
  top: -130px;
  left: -130px;
  background: rgba(108, 99, 255, 0.48);
}

.background-glow--two {
  top: 180px;
  right: -160px;
  background: rgba(33, 212, 167, 0.32);
}

.topbar,
.privacy-shell {
  position: relative;
  z-index: 1;
}

.topbar {
  width: min(1080px, 100%);
  margin: 0 auto 26px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.brand {
  display: inline-flex;
  align-items: center;
  gap: 11px;
  color: var(--ink);
  text-decoration: none;
}

.brand-icon {
  width: 42px;
  height: 42px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  gap: 3px;
  padding: 10px 9px;
  border-radius: 13px;
  background: linear-gradient(145deg, var(--primary) 0%, var(--primary-strong) 100%);
  box-shadow: 0 10px 28px rgba(85, 72, 246, 0.24);
  transform: rotate(-1deg);
}

.brand-icon span {
  display: block;
  width: 5px;
  border-radius: 999px;
  background: #fff;
  transform: skewX(-13deg);
}

.brand-icon span:nth-child(1) { height: 13px; opacity: 0.82; }
.brand-icon span:nth-child(2) { height: 20px; }
.brand-icon span:nth-child(3) { height: 16px; opacity: 0.92; }

.brand-text {
  display: flex;
  flex-direction: column;
  line-height: 1.1;
}

.brand-text strong {
  font-size: 1rem;
  letter-spacing: -0.02em;
}

.brand-text small {
  margin-top: 4px;
  color: var(--muted);
  font-size: 0.72rem;
}

.home-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 44px;
  padding: 0 16px;
  border: 1px solid rgba(108, 99, 255, 0.18);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.78);
  box-shadow: 0 8px 28px rgba(20, 22, 35, 0.06);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  color: #4f46df;
  font-size: 0.9rem;
  font-weight: 700;
  text-decoration: none;
  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;
}

.home-button svg {
  width: 18px;
  height: 18px;
  fill: none;
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.home-button:hover {
  transform: translateY(-2px);
  border-color: rgba(108, 99, 255, 0.34);
  box-shadow: 0 13px 34px rgba(20, 22, 35, 0.09);
}

.privacy-shell {
  width: min(920px, 100%);
  margin: 0 auto;
}

.privacy-hero {
  position: relative;
  overflow: hidden;
  padding: 52px 56px 46px;
  border: 1px solid rgba(255, 255, 255, 0.75);
  border-radius: 26px 26px 0 0;
  background:
    linear-gradient(135deg, rgba(84, 72, 246, 0.98) 0%, rgba(108, 99, 255, 0.96) 54%, rgba(47, 205, 170, 0.92) 150%);
  box-shadow: 0 22px 60px rgba(70, 66, 173, 0.16);
  color: #fff;
}

.privacy-hero::before,
.privacy-hero::after {
  content: '';
  position: absolute;
  border-radius: 999px;
  pointer-events: none;
}

.privacy-hero::before {
  width: 280px;
  height: 280px;
  top: -150px;
  right: -40px;
  border: 1px solid rgba(255, 255, 255, 0.18);
}

.privacy-hero::after {
  width: 170px;
  height: 170px;
  right: 50px;
  bottom: -115px;
  background: rgba(255, 255, 255, 0.07);
}

.eyebrow {
  position: relative;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  padding: 7px 11px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.1);
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

h1 {
  position: relative;
  z-index: 1;
  max-width: 650px;
  margin: 18px 0 10px;
  font-size: clamp(2.05rem, 5vw, 3.45rem);
  line-height: 1.04;
  letter-spacing: -0.05em;
}

.hero-description {
  position: relative;
  z-index: 1;
  max-width: 610px;
  margin: 0;
  color: rgba(255, 255, 255, 0.82);
  font-size: 1rem;
  line-height: 1.65;
}

.updated {
  position: relative;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-top: 24px;
  color: rgba(255, 255, 255, 0.76);
  font-size: 0.82rem;
  font-weight: 600;
}

.updated-dot {
  width: 7px;
  height: 7px;
  border-radius: 999px;
  background: #8ef5d9;
  box-shadow: 0 0 0 5px rgba(142, 245, 217, 0.12);
}

.privacy-container {
  position: relative;
  padding: 52px 56px 58px;
  border: 1px solid rgba(233, 233, 243, 0.92);
  border-top: 0;
  border-radius: 0 0 26px 26px;
  background: var(--surface);
  box-shadow: 0 22px 60px rgba(23, 25, 42, 0.07);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  line-height: 1.78;
  color: #3d4050;
}

.privacy-container > p:first-child {
  margin-top: 0;
  padding: 18px 20px;
  border: 1px solid rgba(108, 99, 255, 0.12);
  border-radius: 14px;
  background: linear-gradient(135deg, rgba(108, 99, 255, 0.07), rgba(33, 212, 167, 0.05));
  color: #353849;
}

h2 {
  position: relative;
  margin: 38px 0 13px;
  padding-left: 17px;
  color: #171928;
  font-size: 1.12rem;
  line-height: 1.35;
  letter-spacing: -0.02em;
}

h2::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0.19em;
  width: 4px;
  height: 1.15em;
  border-radius: 999px;
  background: linear-gradient(180deg, var(--primary), var(--accent));
}

p,
li {
  font-size: 0.96rem;
}

p {
  margin: 0 0 16px;
}

strong {
  color: #222535;
}

ul {
  margin: 8px 0 18px;
  padding-left: 0;
  list-style: none;
}

li {
  position: relative;
  margin-bottom: 10px;
  padding-left: 25px;
}

li::before {
  content: '';
  position: absolute;
  top: 0.66em;
  left: 3px;
  width: 7px;
  height: 7px;
  border-radius: 999px;
  background: var(--primary);
  box-shadow: 0 0 0 4px var(--primary-soft);
}

a {
  color: var(--primary-strong);
}

.privacy-container a {
  font-weight: 700;
  text-decoration: none;
  border-bottom: 1px solid rgba(85, 72, 246, 0.24);
}

.privacy-container a:hover {
  border-bottom-color: currentColor;
}

.privacy-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 24px 8px 0;
  color: var(--muted);
}

.privacy-footer div {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.privacy-footer strong {
  font-size: 0.9rem;
}

.privacy-footer span,
.privacy-footer a {
  font-size: 0.8rem;
}

.privacy-footer a {
  color: var(--primary-strong);
  font-weight: 700;
  text-decoration: none;
}

@media (max-width: 720px) {
  .privacy-page {
    padding: 16px 12px 32px;
  }

  .topbar {
    margin-bottom: 18px;
  }

  .brand-text small {
    display: none;
  }

  .home-button {
    min-height: 42px;
    padding: 0 13px;
    font-size: 0.82rem;
  }

  .privacy-hero {
    padding: 38px 26px 34px;
    border-radius: 22px 22px 0 0;
  }

  .privacy-container {
    padding: 36px 24px 42px;
    border-radius: 0 0 22px 22px;
  }

  .privacy-container > p:first-child {
    padding: 15px 16px;
  }

  h2 {
    margin-top: 34px;
  }

  .privacy-footer {
    align-items: flex-start;
    flex-direction: column;
    gap: 10px;
    padding-inline: 4px;
  }
}

@media (max-width: 460px) {
  .brand-icon {
    width: 38px;
    height: 38px;
    border-radius: 11px;
  }

  .brand-text strong {
    font-size: 0.92rem;
  }

  .home-button span {
    font-size: 0;
  }

  .home-button span::after {
    content: 'Home';
    font-size: 0.82rem;
  }

  .privacy-hero {
    padding-inline: 21px;
  }

  .privacy-container {
    padding-inline: 20px;
  }
}
</style>